import { Button, Card } from 'antd';
import { CalendarClockIcon, CheckCircle } from 'lucide-react';
import { markoCalendlyURL } from '../../config';

const Calendly = () => {
	return (
		<>
			<div className="h-screen overflow-y-auto w-full flex flex-col justify-center ">
				<div className="w-[90%] mx-auto p-6">
					<Card className="shadow-2xl rounded-3xl border-0 bg-white/80 backdrop-blur-sm p-1 overflow-hidden mt-5">
						<div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-blue-500 via-purple-500 to-indigo-500" />

						<div className="w-20 h-20 flex items-center justify-center bg-green-50 rounded-full mx-auto">
							<CheckCircle size={30} className="text-green-500" />
						</div>
						<div className="text-center mt-4">
							<h1 className="text-3xl font-bold mb-2">
								<span className="bg-gradient-to-r from-yellow-400 to-orange-400 bg-clip-text text-transparent">
									Congratulations!
								</span>{' '}
								🎉
							</h1>
							<p className="text-gray-500 text-sm">
								You're a good fit for our premium partnership program
							</p>
						</div>
						<div className="rounded-2xl bg-blue-50 p-4 text-center">
							<CalendarClockIcon size={40} className="text-blue-500 block mx-auto" />
							<h2 className="text-lg font-bold text-blue-500 mb-2 mt-2">
								Next Step: Schedule Your Call
							</h2>
							<p className="text-gray-500 text-sm">
								Book a 30-minute strategy session with our partnership team
							</p>
						</div>
						<a href={markoCalendlyURL} rel="noreferrer">
							<Button className="w-full my-7" type="primary" size="large">
								<span className="text-white font-semibold">Schedule Your Meeting</span>
							</Button>
						</a>
						<p className="text-gray-500 text-center">
							We'll discuss your specific needs and how we can help scale your business
						</p>
					</Card>
				</div>
			</div>
		</>
	);
};

export default Calendly;
